"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalEditorMapOverlay = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_shared_1 = require("@ikegps/core-shared");
const core_shared_2 = require("@ikegps/core-shared");
const lodash_1 = require("lodash");
const lodash_2 = require("lodash");
const mobx_1 = require("mobx");
const mithril_component_1 = require("../../components/mithril.component");
const i18n_1 = require("../../i18n");
const theme_1 = require("../../components/theme");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const page_state_1 = require("../../state/page.state");
const classnames_1 = require("../../util/classnames");
const projection_cache_1 = require("../google/projection.cache");
const map_point_generic_1 = require("./map.point.generic");
const map_line_generic_1 = require("./map.line.generic");
const map_line_1 = require("./map.line/map.line");
const map_point_1 = require("./map.point/map.point");
const point_collection_cache_1 = require("./point.collection.cache");
const store_1 = require("../../store");
const CSS = {
    container: 'c-PhotomeasureOverlay',
    orca: 'c-PhotomeasureOverlay__device',
    orcaIcon: 'c-PhotomeasureOverlay__orcaIcon',
    fov: 'c-PhotomeasureOverlay__fov',
    fovSprite: 'c-PhotomeasureOverlay__fovSprite',
    label: 'c-PhotomeasureOverlay__label',
    line: 'c-MapOverlayLayer__line',
    point: 'c-MapOverlayLayer__point',
    hidden: 'c-MapOverlayLayer--hidden',
};
const Style = {
    [CSS.container]: {
        position: 'absolute',
    },
    [CSS.orca]: {
        position: 'absolute',
        transform: 'translate3d(-16px, -16px, -1px)',
        width: '32px',
        height: '32px',
        borderRadius: '16px',
        boxShadow: theme_1.DefaultTheme.shadow.box.dp4,
    },
    [CSS.orcaIcon]: {
        width: '32px',
        height: '32px',
        transformOrigin: '50% 50%',
    },
    [CSS.fov]: {
        position: 'absolute',
        left: 0,
        top: 0,
        transform: 'translate3d(-75px, -129px, -1px)',
    },
    [CSS.fovSprite]: {
        width: '150px',
        height: '129px',
        transformOrigin: '50% 100%',
    },
    [CSS.label]: {
        paddingTop: '20px',
    },
    [CSS.hidden]: {
        display: 'none',
    },
};
(0, theme_1.addStyles)(Style);
class TopologicalEditorMapOverlay extends mithril_component_1.IMithrilComponent {
    constructor(options) {
        super();
        this.options = options;
        this.origin = new google.maps.LatLng(0, 0);
        this.el = null;
        this.boundString = mobx_1.observable.box('', { name: 'BoundsString' });
        this.collections = [];
        this.selectedCollectionRevision = null;
        this.selectedVectorId = null;
        this.visible = true;
        this.collectionHoverRevision = null;
        this.collectionAndVectorHoverId = null;
        this.viewCollectionLabels = false;
        this.hideTitles = false;
        this.selectedVectorMoveDelta = {
            x: 0,
            y: 0,
        };
        this.name = 'TopologicalEditorMapOverlay';
        const { collections, selectedCollectionRevision, measurementState } = options;
        this.overlay = new google.maps.OverlayView();
        this.overlay.setMap(options.map);
        this.selectedCollectionRevision = selectedCollectionRevision || null;
        this.collections = collections || [];
        this.measurementState = measurementState;
        this.overlay.onAdd = () => {
            this.el = this.overlay.getPanes().overlayMouseTarget;
            services_1.Services.Render.mount(this.el, this, this.name);
        };
        this.overlay.onRemove = () => {
            if (this.el) {
                services_1.Services.Render.mount(this.el, null, this.name);
            }
        };
        this.overlay.draw = this.onDraw.bind(this);
        this.boundVectorHandleMouseMove = this.onVectorHandleDragMove.bind(this);
        this.boundVectorHandleMouseUp = this.onVectorHandleMouseUp.bind(this);
    }
    onRemove() {
        if (this.el) {
            services_1.Services.Render.mount(this.el, null, this.name);
        }
        if (this.overlay) {
            this.overlay.setMap(null);
        }
    }
    updateState() {
        this.setZoom(this.options.map.getZoom());
        this.setBounds(this.options.map.getBounds());
    }
    setZoom(zoom) {
        this.zoom = zoom;
    }
    setBounds(bounds) {
        const newBounds = bounds.toUrlValue();
        if (newBounds === this.boundString.get()) {
            return;
        }
        this.bounds = bounds;
        this.boundString.set(newBounds);
    }
    onDraw() {
        const reset = this.verifyProjection();
        this.updateState();
        if (reset) {
            services_1.Services.Render.render(this.el, this.view());
        }
    }
    setCollections(newCollections) {
        this.collections = newCollections.filter(Boolean);
    }
    setSelectedCollectionRevision(revision) {
        this.selectedCollectionRevision = revision;
    }
    setSelectedVectorId(id) {
        this.selectedVectorId = id;
    }
    hide() {
        this.visible = false;
        this.overlay.setMap(null);
    }
    show() {
        this.visible = true;
        this.overlay.setMap(this.options.map);
    }
    setInitialMove(coords) {
        this.selectedVectorInitialMove = coords;
    }
    setInferredMoveDelta(coords) {
        this.selectedVectorMoveDelta = {
            x: coords.x - this.selectedVectorInitialMove.x,
            y: coords.y - this.selectedVectorInitialMove.y,
        };
    }
    setCapture(capture) {
        this.selectedCapture = capture;
        this.onDraw();
    }
    resetMoveDelta() {
        this.selectedVectorMoveDelta = {
            x: 0,
            y: 0,
        };
    }
    onVectorHandleMouseDown(event) {
        if (this.measurementState && this.measurementState.isActive && !this.measurementState.isPaused) {
            return;
        }
        if (this.options.onVectorDragStart) {
            this.options.onVectorDragStart();
        }
        this.setInitialMove((0, lodash_1.pick)(event, ['x', 'y']));
        window.addEventListener('mouseup', this.boundVectorHandleMouseUp);
        window.addEventListener('mousemove', this.boundVectorHandleMouseMove);
    }
    onVectorHandleDragMove(event) {
        this.setInferredMoveDelta((0, lodash_1.pick)(event, ['x', 'y']));
    }
    onVectorHandleMouseUp() {
        window.removeEventListener('mouseup', this.boundVectorHandleMouseUp);
        window.removeEventListener('mousemove', this.boundVectorHandleMouseMove);
        // See if any of the deltas have changed (ie not 0);
        if (Object.values(this.selectedVectorMoveDelta).some(Boolean)) {
            const vector = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionVectors(this.selectedCollectionRevision).find((k) => this.selectedCollectionRevision + k.field.id === this.selectedVectorId);
            const { x, y } = projection_cache_1.PointCache.getPoint(vector.target.latitude, vector.target.longitude);
            const terminal = new google.maps.Point(x + this.selectedVectorMoveDelta.x, y + this.selectedVectorMoveDelta.y);
            const { lat, lng } = this.overlay.getProjection().fromDivPixelToLatLng(terminal);
            const nextVector = core_shared_2.IkeGeodesic.getVector(vector.field.collection.location, {
                latitude: lat(),
                longitude: lng(),
                altitude: 0,
            });
            vector.field.Mutator.manual(nextVector);
            point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionVectors(this.selectedCollectionRevision);
            this.resetMoveDelta();
        }
    }
    setCollectionHoveredRevision(revision) {
        this.collectionHoverRevision = revision;
    }
    setVectorHoverId(id) {
        this.collectionAndVectorHoverId = id;
    }
    setHideTitles(hide) {
        this.hideTitles = hide;
    }
    setMeasurementState(state) {
        this.measurementState = state;
    }
    verifyProjection() {
        const projection = this.overlay.getProjection();
        if (projection == null) {
            projection_cache_1.PointCache.reset();
            return true;
        }
        projection_cache_1.PointCache.setProjection(projection);
        const point = projection.fromLatLngToDivPixel(this.origin);
        const oldPoint = projection_cache_1.PointCache.getPoint(this.origin.lat(), this.origin.lng());
        if (point.x !== oldPoint.x || point.y !== oldPoint.y) {
            projection_cache_1.PointCache.reset();
            return true;
        }
        return false;
    }
    canSeeFieldOfView() {
        return services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MAP_FIELD_OF_VIEW);
    }
    get nodes() {
        this.verifyProjection();
        const output = this.collections.reduce((acc, col) => {
            let location;
            let collection = col;
            if (store_1.AppStore.Collection.has(col.revision)) {
                collection = store_1.AppStore.Collection.get(col.revision);
            }
            location = collection.location;
            const point = projection_cache_1.PointCache.getGeoPoint({
                type: 'point',
                coordinates: [(0, lodash_2.get)(location, ['longitude'], 0), (0, lodash_2.get)(location, ['latitude'], 0)],
            });
            const vectors = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionVectors(collection);
            const lines = vectors
                // Check to make sure that the vectors that are there actually exist before drawing them
                .filter((vector) => vector.field.value)
                .map((vector) => new map_line_1.MapLine({
                vector,
                initialPoint: point,
                isSelected: this.selectedVectorId === collection.revision + vector.field.id &&
                    vector.field.collection.revision === this.selectedCollectionRevision,
                drawLabels: this.showLabelsOnMap(),
                showVectorLabel: [this.collectionAndVectorHoverId, this.selectedVectorId].includes(collection.revision + vector.field.id),
                onClick: () => {
                    this.options.onVectorClick(collection.revision, vector.field.id);
                    this.setSelectedVectorId(collection.revision + vector.field.id);
                },
                onVectorMouseOver: () => {
                    this.setVectorHoverId(collection.revision + vector.field.id);
                },
                onVectorMouseOut: () => {
                    this.setVectorHoverId(null);
                },
                onVectorHandleMouseDown: vector.field.isCollectionLink()
                    ? lodash_1.noop
                    : (event) => {
                        event.preventDefault();
                        event.stopPropagation();
                        this.onVectorHandleMouseDown(event);
                    },
                vectorHandleMoveDelta: this.selectedVectorMoveDelta,
            }));
            let poleAccuracy = point_collection_cache_1.TopologicalPointCollectionCache.getCollectionPoleAccuracy(collection);
            const pointView = map_point_1.MapPoint.view({
                collection,
                point,
                isCollectionSelected: collection.revision === this.selectedCollectionRevision,
                poleAccuracy,
                onClick: () => {
                    if (page_state_1.CurrentState.CollectionLink.isLinking) {
                        page_state_1.CurrentState.CollectionLink.completeLinking(collection);
                        return;
                    }
                    this.options.onCollectionClick(collection.revision);
                    this.setSelectedVectorId(null);
                },
                onCollectionMouseOver: () => {
                    this.setCollectionHoveredRevision(collection.revision);
                },
                onCollectionMouseOut: () => {
                    this.setCollectionHoveredRevision(null);
                },
                showCollectionTitle: this.collectionHoverRevision === collection.revision,
                showTitlesOnMap: this.showLabelsOnMap(),
            });
            const pointLayer = pointView
                ? (0, mithril_1.m)('div', {
                    key: `layer-point-${collection.revision}`,
                    className: (0, classnames_1.classNames)(CSS.point, {
                        [CSS.hidden]: !this.visible,
                    }),
                }, pointView)
                : null;
            const lineLayer = lines.length
                ? (0, mithril_1.m)('div', {
                    key: `layer-line-${collection.revision}`,
                    className: (0, classnames_1.classNames)(CSS.line, {
                        [CSS.hidden]: !this.visible,
                    }),
                }, lines.map((x) => x.nodes))
                : null;
            return [lineLayer, ...acc, pointLayer];
        }, []);
        // Add measurement nodes
        output.push(...this.measurementNodes);
        const projection = this.overlay.getProjection();
        if (this.selectedCapture && this.selectedCapture.device && this.canSeeFieldOfView() && projection) {
            const { latitude, longitude } = this.selectedCapture.device;
            const point = projection.fromLatLngToDivPixel(new google.maps.LatLng({
                lat: latitude,
                lng: longitude,
            }));
            const photomeasureNodes = (0, mithril_1.m)('div', {
                className: CSS.container,
                style: {
                    left: `${point.x}px`,
                    top: `${point.y}px`,
                    zIndex: -1,
                },
            }, [
                (0, mithril_1.m)('div', {
                    className: CSS.fov,
                }, (0, mithril_1.m)('img', {
                    src: (0, theme_1.assetPath)('/images/fov-cone.svg'),
                    className: CSS.fovSprite,
                    style: {
                        transform: `rotate(${this.selectedCapture.orientation.bearing}rad)`,
                    },
                })),
                (0, mithril_1.m)('div', {
                    className: CSS.orca,
                }, (0, mithril_1.m)('img', {
                    src: (0, theme_1.assetPath)('/images/ike-device.svg'),
                    className: CSS.orcaIcon,
                    style: {
                        transform: `rotate(${this.selectedCapture.orientation.bearing}rad)`,
                    },
                })),
                (0, mithril_1.m)('div', {
                    className: CSS.label,
                }, core_shared_1.IkeUnit.display(this.selectedCapture.distance, services_1.Services.UserSettings.units)),
            ]);
            output.push(photomeasureNodes);
        }
        return output.filter(Boolean);
    }
    view() {
        return mithril_1.m.fragment({}, this.nodes);
    }
    toggleViewTitles() {
        this.viewCollectionLabels = !this.viewCollectionLabels;
    }
    showLabelsOnMap() {
        if (this.hideTitles) {
            return false;
        }
        return this.viewCollectionLabels;
    }
    worldPointToPixel(latLng) {
        const projection = this.overlay.getProjection();
        if (!projection) {
            return null;
        }
        return projection.fromLatLngToDivPixel(latLng);
    }
    renderMeasurementPoint(point) {
        const pixel = this.worldPointToPixel(point.location);
        if (!pixel) {
            return null;
        }
        return map_point_generic_1.GenericMapPoint.view({
            key: `measurement-${point.id}`,
            point: pixel,
            backgroundColor: '#FFFFFF',
            onClick: (e) => {
                e.stopPropagation();
                if (this.measurementState) {
                    this.measurementState.removePoint(point.id);
                }
            },
            title: (0, i18n_1.Translate)(i18n_1.T.MEASUREMENT_CLICK_TO_REMOVE),
        });
    }
    renderMeasurementLine(start, end) {
        const startPixel = this.worldPointToPixel(start.location);
        const endPixel = this.worldPointToPixel(end.location);
        if (!startPixel || !endPixel) {
            return null;
        }
        const line = map_line_generic_1.GenericMapLine.view({
            key: `measurement-line-${start.id}-${end.id}`,
            start: startPixel,
            end: endPixel,
            color: '#FFFFFF',
            strokeWidth: '1px',
        });
        // Calculate distance and bearing for label
        const startLoc = {
            latitude: start.location.lat(),
            longitude: start.location.lng(),
            altitude: 0,
        };
        const endLoc = {
            latitude: end.location.lat(),
            longitude: end.location.lng(),
            altitude: 0,
        };
        const vector = core_shared_2.IkeGeodesic.getVector(startLoc, endLoc);
        const distance = core_shared_1.IkeUnit.display(vector.distance, services_1.Services.UserSettings.units);
        // Calculate midpoint for label position
        const midX = (startPixel.x + endPixel.x) / 2;
        const midY = (startPixel.y + endPixel.y) / 2;
        const label = (0, mithril_1.m)('div', {
            key: `measurement-label-${start.id}-${end.id}`,
            style: {
                position: 'absolute',
                left: `${midX}px`,
                top: `${midY}px`,
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                color: '#FFFFFF',
                padding: '2px 6px',
                borderRadius: '3px',
                fontSize: '11px',
                fontWeight: '500',
                whiteSpace: 'nowrap',
                pointerEvents: 'none',
                zIndex: 1,
            },
        }, distance);
        return [line, label];
    }
    get measurementNodes() {
        if (!this.measurementState || this.measurementState.points.length === 0) {
            return [];
        }
        const points = this.measurementState.points;
        const lineNodes = points.slice(0, -1).flatMap((point, index) => {
            const nextPoint = points[index + 1];
            if (!nextPoint)
                return [];
            return this.renderMeasurementLine(point, nextPoint) || [];
        });
        const pointNodes = points.map((point) => this.renderMeasurementPoint(point)).filter(Boolean);
        return [...lineNodes, ...pointNodes];
    }
}
exports.TopologicalEditorMapOverlay = TopologicalEditorMapOverlay;
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorMapOverlay.prototype, "bounds", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorMapOverlay.prototype, "zoom", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorMapOverlay.prototype, "collections", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorMapOverlay.prototype, "selectedCollectionRevision", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorMapOverlay.prototype, "selectedVectorId", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorMapOverlay.prototype, "visible", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorMapOverlay.prototype, "collectionHoverRevision", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorMapOverlay.prototype, "collectionAndVectorHoverId", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorMapOverlay.prototype, "viewCollectionLabels", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorMapOverlay.prototype, "hideTitles", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorMapOverlay.prototype, "selectedVectorMoveDelta", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorMapOverlay.prototype, "selectedVectorInitialMove", void 0);
tslib_1.__decorate([
    mobx_1.observable
], TopologicalEditorMapOverlay.prototype, "selectedCapture", void 0);
tslib_1.__decorate([
    mobx_1.action.bound
], TopologicalEditorMapOverlay.prototype, "updateState", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "setZoom", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "setBounds", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "setCollections", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "setSelectedCollectionRevision", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "setSelectedVectorId", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "hide", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "show", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "setInitialMove", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "setInferredMoveDelta", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "setCapture", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "resetMoveDelta", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "onVectorHandleMouseDown", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "onVectorHandleDragMove", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "onVectorHandleMouseUp", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "setCollectionHoveredRevision", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "setVectorHoverId", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "setHideTitles", null);
tslib_1.__decorate([
    mobx_1.action
], TopologicalEditorMapOverlay.prototype, "setMeasurementState", null);
//# sourceMappingURL=topological.editor.map.overlay.js.map